import axiosApi from "../axiosInstance";

const getAssetStatus = async () => {
    try {
        const response = await axiosApi.get(`/AssetStatus/GetStatusList`);
        return response?.data;

    } catch (error) {
        console.log("Error getOwnerShipTypeList===>:", error);
         return error?.response?.data;
    }
};


const addAssetStatus= async (body) => {
    try {
        const response = await axiosApi.post(`AssetStatus/CreateStatus`, body);
        return response?.data;
    } catch (error) {
        console.log("Error OwnerShipType ===>", error);
         return error?.response?.data;
    }
};

export const AssetStatusService = {
    getAssetStatus,
    addAssetStatus
}